import { PackageCardModel } from '@vp/digital-common-data-model-lib-ubik'
import { useLogger } from '@vp/ubik-context'

interface PlanSessionData {
  plan: PackageCardModel
  timestamp: number
}

const useSessionPlan = (key: string = 'vxw_websites_shorter_freemium_to_premium') => {
  const logger = useLogger()
  const ONE_HOUR = 60 * 60 * 1000

  const setSelectedPlan = (plan: PackageCardModel): void => {
    const data: PlanSessionData = {
      plan,
      timestamp: Date.now(),
    }
    sessionStorage.setItem(key, JSON.stringify(data))
  }

  const getSelectedPlan = (): PackageCardModel | null => {
    const rawData = sessionStorage.getItem(key)
    if (!rawData) return null

    try {
      const data: PlanSessionData = JSON.parse(rawData)
      const isExpired = Date.now() - data.timestamp > ONE_HOUR
      sessionStorage.removeItem(key)
      if (isExpired) {
        return null
      }

      return data.plan
    } catch (error) {
      logger.error('Error parsing session storage', error)
      sessionStorage.removeItem(key)
      return null
    }
  }

  return { setSelectedPlan, getSelectedPlan }
}

export default useSessionPlan
